module.exports = __webpack_public_path__ + "img/tutorial-02.06682bad.svg";